var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<img" + (jade.attr("src", require('./../tip-lightbulb-copy-3.svg'), true, true)) + " width=\"55\" alt=\"\"><br><div style=\"width: 150px;\"><h3>Use \"Forms\" to create and send applications to prospective tenants</h3></div><div class=\"dots\"><a href=\"#\" class=\"dot dot1-button active\"></a><a href=\"#\" onClick=\"window.Shepherd.activeTour.show('intro-step2')\" class=\"dot dot2-button\"></a><a href=\"#\" onClick=\"window.Shepherd.activeTour.show('intro-step3')\" class=\"dot dot3-button\"></a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/forms/tour/intro/step1.jade
// module id = 741
// module chunks = 0